/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const BookingTabRow = styled.div`
	padding: 0 16px;
`;
